"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidePaneStack = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useSelfActions_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelfActions"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const react_1 = __importStar(require("react"));
const SidePane_1 = __importDefault(require("./SidePane"));
function SidePaneStack(props) {
    const { hasFeature } = (0, useSelfActions_1.default)();
    const sp = props.sidePanes.filter(x => !!x).filter(x => !x.flag || hasFeature(x.flag));
    const [openIdx, setOpenIdx] = (0, react_1.useState)(sp.findIndex(p => p.startOpen));
    const handleChangeOpen = (0, useCallforward_1.default)(idx => open => {
        if (open && openIdx !== idx)
            setOpenIdx(idx);
        else
            setOpenIdx(undefined);
    }, [openIdx]);
    return (react_1.default.createElement(Horizontal_1.default, { shrink: true, style: {
            position: 'relative',
        } }, sp.map((sidePane, idx) => (react_1.default.createElement(SidePane_1.default, Object.assign({ key: 'sidePane' + idx, forceClose: openIdx !== idx }, sidePane, { stacked: true, color: idx === 0 ? lib_palette_1.default.HelixNotificationBold : lib_palette_1.default.GreyBlue, onChangeOpen: handleChangeOpen(idx) }))))));
}
exports.SidePaneStack = SidePaneStack;
exports.default = SidePaneStack;
